import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Box,
  Divider,
  DialogContent,
  GridList,
  GridListTile,
  ButtonBase,
  DialogActions,
  Button,
  GridListTileBar,
  Tooltip,
  TextField,
  Paper,
  Checkbox,
  DialogContentText,
  alpha,
} from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import * as React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { colors, titleCase } from "../constants/constants";
import { getBase64 } from "../utils/AppUtils";
import { AssetsService } from "../services/AssetsService";
import LoadingComponents from "../components/LoadingComponents";
import { EventEmitter } from "../events/EventEmitter";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import ReplayIcon from "@material-ui/icons/Replay";
import ClearIcon from "@material-ui/icons/Clear";
import DeleteIcon from "@material-ui/icons/Delete";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      overflow: "hidden",
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      "border-color": "blue",
      border: "1px solid ",
      marginLeft: 0,
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(1),
        width: "auto",
      },
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    imageStyle: {
      "max-width": 80,
      "max-height": 80,
      overflow: "hidden",
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    inputRoot: {
      color: "inherit",
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "12ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    gridList: {
      width: "100%",
      height: 450,
    },
    icon: {
      color: "rgba(255, 255, 255, 0.54)",
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
// let fileName: "";
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  images: any;
  onClose: any;
  onSelectedItem: any;
  companyData: any;
}
class RenderImagesDialog extends React.Component<Props> {
  state = {
    images: Array<any>(),
    isLoading: false,
    hasLoaded: false,
    deleting: false,
    deleted: 0,
    fileName: "",
    openConfirmationDialog: false,
    totalSize: 0,
    totalLoaded: 0,
  };
  handleClose = () => {
    this.props.onClose();
  };

  handleListItemClick = () => {
    this.props.onClose();
  };

  componentDidMount = () => {
    // this.setState(
    //   {
    //     images: this.props.images,
    //   },
    //   () => {
    this.reloadAssets();
    // }
    // );
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.companyData !== this.props.companyData) {
      this.reloadAssets();
      //   this.setState(
      //     {
      //       images: this.props.images,
      //     },
      //     () => {
      //       if (!this.state.hasLoaded) {
      //         this.reloadAssets();
      //       }
      //     }
      //   );
    }
  };
  selectImage = (index: any) => {
    let images = this.state.images.map((image: any, mIndex: any) => {
      if (mIndex === index) {
        image.checked = !image.checked;
      }
      return image;
    });
    this.setState({
      images: images,
    });
  };

  onTextChaned = (value: any) => {
    if (value) {
      let currentImages = this.state.images.filter((imageItem: any) => {
        let fileName = titleCase(
          imageItem.item.filename.replace(".png", "").replace(/_/g, " ")
        );
        return fileName.toUpperCase().includes(value.toUpperCase());
      });
      this.setState({
        images: currentImages,
      });
    } else {
      this.setState({
        images: this.props.images,
      });
    }
  };

  handleOnTextChanged = (event: any) => {
    this.setState({
      fileName: event.target.value,
    });
  };
  handleCapture = async (event: any) => {
    var fileTypes = ["jpg", "jpeg", "png"];
    let isUniqueName = this.state.images.filter((imageItem: any) => {
      let filenameItem = titleCase(
        imageItem.item.filename.replace(".png", "").replace(/_/g, " ")
      );
      return filenameItem.toUpperCase() === this.state.fileName.toUpperCase();
    });
    if (
      this.state.fileName &&
      isUniqueName.length === 0 &&
      event.target.files.length > 0 &&
      event.target.files[0]
    ) {
      var extension = event.target.files[0].name.split(".").pop().toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;
      if (isSuccess) {
        let base64Data = await getBase64(event.target.files[0]);
        if (base64Data) {
          this.uploadAsset(this.state.fileName, base64Data, extension);
        }
      }
    } else {
      if (isUniqueName.length > 0) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: "Filename should be unique.",
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: "Filename is required.",
        });
      }
    }
  };

  uploadAsset = (filename: any, base64Data: any, extension: any) => {
    let companyId = this.props.companyData ? this.props.companyData._id : "";
    if (companyId) {
      let assetsService: AssetsService = new AssetsService();
      this.setState({
        isLoading: true,
      });
      assetsService
        .uploadAsset(filename, companyId, base64Data, extension)
        .then((resp) => {
          if (resp && resp.success && resp.asset) {
            this.setState(
              {
                isLoading: false,
                fileName: "",
              },
              () => {
                this.reloadAssets();
              }
            );
          }
        });
    }
  };

  reloadAssets = async () => {
    let companyId = this.props.companyData ? this.props.companyData._id : "";
    if (companyId) {
      this.setState({
        isLoading: true,
        images: [],
        totalLoaded: 0,
        totalSize: 0,
      });
      let assetsService: AssetsService = new AssetsService();
      let images = Array<any>();
      let assetsResp = await assetsService.getAssets(companyId);
      if (assetsResp && assetsResp.success && assetsResp.assets) {
        this.setState({
          totalSize: assetsResp.assets.length,
        });
        for (var i = 0; i < assetsResp.assets.length; i++) {
          let imageItem = assetsResp.assets[i];
          let assetObjResp = await assetsService.getAsset(imageItem.filename);
          if (assetObjResp && assetObjResp.success && assetObjResp.data) {
            let imageObj: any = { item: imageItem, base64: assetObjResp.data };
            imageObj.checked = false;
            images.push(imageObj);
            this.setState((prevState: any) => ({
              totalLoaded:
                prevState.totalLoaded >= 100 ? 0 : prevState.totalLoaded + 1,
            }));
          }
        }
        this.setState({
          images: images,
          isLoading: false,
          hasLoaded: true,
        });
      }
    }
  };

  cancelingAssets = async () => {
    this.setState({
      deleting: false,
    });
  };

  deletingAssets = async () => {
    this.setState({
      deleting: true,
    });
  };

  deleteAssets = async () => {
    this.setState({
      openConfirmationDialog: true,
    });
  };

  handleConfirmedDelete = async () => {
    let images = this.state.images.filter((image: any) => {
      return image.checked;
    });
    if (images.length > 0) {
      this.setState({
        isLoading: true,
      });
      let assetsService: AssetsService = new AssetsService();
      let deleted = 0;
      for (var i = 0; i < images.length; i++) {
        let imageItem = images[i];
        let resp = await assetsService.deleteAsset(imageItem.item._id);
        if (resp && resp.response) {
          deleted += 1;
        }
      }
      this.setState(
        {
          isLoading: false,
          deleted: deleted,
          openConfirmationDialog: false,
        },
        () => {
          this.reloadAssets();
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message:
              this.state.deleted > 0
                ? `${this.state.deleted} Images deleted Successfully`
                : "No images deleted.",
          });
        }
      );
    } else {
      EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
        type: SNACKBAR_TYPE.ERROR,
        show: true,
        message: "Please select at least one image.",
      });
    }
  };

  renderConfirmationDialog = () => {
    let images = this.state.images.filter((image: any) => {
      return image.checked;
    });
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openConfirmationDialog}
        onClose={() =>
          this.setState({
            openConfirmationDialog: false,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">
          {`Deleting ${images.length > 1 ? "images" : "image"} `}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure want to delete ${
              images.length > 1 ? "these images" : "the image"
            }`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              this.setState({
                openConfirmationDialog: false,
              })
            }
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => this.handleConfirmedDelete()}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const { open, dialogTitle, onClose, classes, onSelectedItem } = this.props;
    let percetage = this.state.totalLoaded / this.state.totalSize;
    return (
      <React.Fragment>
        {this.renderConfirmationDialog()}
        <Dialog
          fullWidth
          maxWidth={"md"}
          onClose={() => this.handleClose()}
          aria-labelledby="simple-dialog-title"
          open={open}
        >
          <DialogTitle id="simple-dialog-title">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {dialogTitle}
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder="Search…"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  onChange={(event) => this.onTextChaned(event?.target.value)}
                  fullWidth={true}
                  inputProps={{ "aria-label": "search" }}
                />
              </div>
            </div>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <div className={classes.root}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  marginTop: 5,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    flex: 0.8,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label="Enter image name"
                    variant="outlined"
                    value={this.state.fileName}
                    style={{ marginRight: 10, flex: 0.5 }}
                    onChange={this.handleOnTextChanged}
                  />
                  <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="raised-button-file"
                    multiple
                    onChange={(event: any) => this.handleCapture(event)}
                    type="file"
                  />
                  <label htmlFor="raised-button-file">
                    <Paper
                      elevation={3}
                      style={{
                        height: 50,
                        margin: 10,
                        alignSelf: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Button
                        component="span"
                        disableElevation
                        disabled={
                          this.state.fileName && this.state.fileName.length > 0
                            ? false
                            : true
                        }
                        style={{
                          alignSelf: "flex-end",
                          height: "100%",
                          width: "100%",
                          flex: 0.2,
                        }}
                      >
                        <input type="file" style={{ display: "none" }} />
                        UPLOAD IMAGE
                      </Button>
                    </Paper>
                  </label>
                </div>

                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Paper
                    elevation={3}
                    style={{
                      height: 50,
                      margin: 10,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      disableElevation
                      style={{ flex: 0.1, width: "100%", height: "100%" }}
                      onClick={() => this.reloadAssets()}
                    >
                      <ReplayIcon style={{ marginRight: 5 }} />
                      Reload
                    </Button>
                  </Paper>
                  <Paper
                    elevation={3}
                    style={{
                      height: 50,
                      margin: 10,
                      alignSelf: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {this.state.deleting ? (
                      <Button
                        disableElevation
                        style={{ flex: 0.1, width: "100%", height: "100%" }}
                        onClick={() => this.cancelingAssets()}
                      >
                        <ClearIcon style={{ marginRight: 5 }} />
                        Cancel
                      </Button>
                    ) : (
                      <Button
                        disableElevation
                        style={{ flex: 0.1, width: "100%", height: "100%" }}
                        onClick={() => this.deletingAssets()}
                      >
                        <DeleteIcon style={{ marginRight: 5 }} />
                        Delete
                      </Button>
                    )}
                  </Paper>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "grey",
                  width: "100%",
                  height: 0.5,
                  marginTop: 10,
                }}
              />
              <GridList cellHeight={160} className={classes.gridList} cols={3}>
                {this.state.images.map((imageItem: any, index: any) => (
                  <Tooltip
                    title={titleCase(
                      imageItem.item.filename
                        .replace(".png", "")
                        .replace(/_/g, " ")
                    )}
                    aria-label="add"
                    key={index.toString()}
                  >
                    <ButtonBase
                      onClick={() => {
                        let images = this.state.images;
                        images[index].checked = !imageItem.checked;
                        this.state.deleting
                          ? this.setState({
                              images: images,
                            })
                          : onSelectedItem(imageItem);
                      }}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: 120,
                        height: 120,
                        margin: 10,
                      }}
                    >
                      <Box boxShadow={1}>
                        <GridListTile
                          cols={1}
                          style={{
                            width: 100,
                            height: 100,
                          }}
                        >
                          <img
                            className={classes.imageStyle}
                            src={`data:image/jpeg;base64,${imageItem.base64}`}
                            alt={index.toString()}
                          />
                        </GridListTile>
                        {this.state.deleting && (
                          <Checkbox
                            style={{ position: "absolute", top: 0, left: 0 }}
                            checked={imageItem.checked}
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        )}
                        <GridListTileBar
                          style={{ height: 20 }}
                          title={titleCase(
                            imageItem.item.filename
                              .replace(".png", "")
                              .replace(/_/g, " ")
                          )}
                        />
                      </Box>
                    </ButtonBase>
                  </Tooltip>
                ))}
              </GridList>
              <LoadingComponents
                isLoading={this.state.isLoading}
                progress={!isNaN(percetage) ? percetage * 100 : 0}
              />
            </div>
          </DialogContent>
          <Divider />
          <DialogActions>
            {this.state.deleting ? (
              <Button
                onClick={() => {
                  this.deleteAssets();
                }}
              >
                {"DELETE"}
              </Button>
            ) : (
              <Button
                onClick={() => {
                  onClose();
                }}
              >
                {"CANCEL"}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(RenderImagesDialog);
